import HeroSection from "@/components/home/HeroSection";
import FeaturesSection from "@/components/home/FeaturesSection";
import UpcomingSection from "@/components/home/UpcomingSection";
import WebAppSection from "@/components/home/WebAppSection";
import ScreensSection from "@/components/home/ScreensSection";
import ContactSection from "@/components/home/ContactSection";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <FeaturesSection />
      <UpcomingSection />
      <WebAppSection />
      <ScreensSection />
      <ContactSection />
    </div>
  );
}
